module.exports = __webpack_public_path__ + "static/media/time_series_analyzer_mobile.232e1f5a.png";